export const enforceLimitedDigits = limit => (value, previousValue) => {
  if (!value) return value
  const onlyNums = value.replace(/[^\d]/g, '')
  if (value.length > limit) return previousValue
  return onlyNums
}
